<template>
  <div class="login">
    <div class="text-right">
      <el-button
        type="primary"
        id="google-login-account-dialog"
        class="button-block"
        :plain="isPlainButton"
        @click="$firebase.signInGoogle()"
        >Googleアカウントで会員登録・ログイン</el-button
      >
    </div>
    <p class="addition">ご利用のGoogleアカウントでログインできます</p>
    <div
      class="btn_google"
      style="background-color: #000; border: 2px solid #000"
    >
      <el-button
        type="primary"
        id="google-login-account-dialog"
        class="button-block"
        style="
          background-color: #000;
          border-color: #000;
          color: #fff;
          font-size: 15px;
        "
        :plain="isPlainButton"
        @click="$firebase.signInApple()"
        >AppleIDで会員登録・ログイン</el-button
      >
    </div>
    <p class="addition">ご利用のAppleアカウントでログインできます</p>
    <div class="horizontal-text" v-if="$site.appFlag != 'b'">
      <span>または</span>
    </div>
    <div class="mail-link-login" v-if="$site.appFlag != 'b'">
      <el-form
        ref="mailLoginForm"
        :model="mailLogin"
        :rules="mailLoginRules"
        @submit.native.prevent
      >
        <el-form-item :required="true" prop="email">
          <el-input
            v-model="mailLogin.email"
            type="email"
            autocomplete
            name="mail-link-input"
            placeholder="yagish@example.com"
            :disabled="loginEmailSending"
          ></el-input>
        </el-form-item>
        <el-button
          type="primary"
          id="email-login-account-dialog"
          class="button-block"
          :plain="isPlainButton"
          @click="mailSubmit"
          v-loading="loginEmailSending"
          >メールでリンクを送る</el-button
        >
      </el-form>
      <p class="addition">
        メールに届いたリンクをクリックするだけでかんたんにログインできます。
      </p>
    </div>
  </div>
</template>
<style lang="scss" scoped>
$light-gray: #dcdfe6;

.login {
  max-width: 320px;
  margin: 0.5rem auto;
  border-radius: 0.25rem;
  border: solid 1px $light-gray;
  padding: 1rem;
  box-sizing: border-box;

  button {
    margin-top: 0.5rem;
  }

  .el-form-item {
    margin: 0;
  }

  .addition {
    font-size: 0.75rem;
    margin: 0.5rem 0;
  }
}
</style>
<style lang="scss">
.login {
  .el-input {
    position: static;
  }

  .el-form-item__error {
    position: static;
    text-align: left;
  }
}
</style>
<script>
import { getCurrentInstance, onMounted, onUnmounted } from 'vue'
import { emitter, SIGN_IN_MAIL_SEND } from '@/plugins/emitter'
export default {
  setup() {
    const vm = getCurrentInstance().proxy
    onMounted(() => {
      emitter.on(SIGN_IN_MAIL_SEND, vm.resetloginEmail)
      emitter.on('sing-in-mail-failed', vm.resetloginEmail)
    })
    onUnmounted(() => {
      emitter.off(SIGN_IN_MAIL_SEND, vm.resetloginEmail)
      emitter.off('sing-in-mail-failed', vm.resetloginEmail)
    })
    return {}
  },
  props: {
    isPlainButton: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      loginEmailSending: false,
      mailLogin: {
        email: ''
      },
      mailLoginRules: {
        email: [
          {
            required: true,
            message: 'メールアドレスをいれてね',
            trigger: 'blur'
          },
          {
            required: true,
            type: 'email',
            message: 'メールアドレスをいれてね',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    resetloginEmail: function () {
      this.mailLogin.email = ''
      this.loginEmailSending = false
      this.$refs.mailLoginForm.resetFields()
    },
    mailSubmit: function () {
      const app = this
      this.$refs.mailLoginForm.validate(async (valid) => {
        if (!valid) {
          return
        }
        app.$firebase.signInEmail(app.mailLogin.email)
        app.loginEmailSending = true
      })
    }
  }
}
</script>
